import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http : HttpClient) { 

  }

  private apiUrl = 'http://localhost:3000/payment';


  initiatePayment(paymentDetails: any): Observable<any> {
    return this.http.post(environment.API_URL+"/api/pg/order", paymentDetails,{responseType : 'json',observe:"response"});
  }

  login(auth : {username : String, password : String}) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/auth/signin",auth,{responseType : 'json',observe:"response"});
  }

  regenerate(request:any) {
    //console.log(request)
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/regen-token/"+request.username+"/"+request.action,{responseType : 'json',observe:"response"});
  }
  // getPasswordLink(username:any){
  //   let httpParam : HttpParams=new HttpParams();
  //   httpParam=httpParam.append("username",username);
  //   return this.http.get(environment.API_URL+"/api/token/getpasswordlink",{observe : "body",params : httpParam, responseType : "json",});

  // }
  getPasswordLink(username:any){
    let params:any = {
     email:username}
    let httpParam : HttpParams=new HttpParams();
   
    return this.http.post(environment.API_URL+"/api/auth/user/aux/link",params,{observe : "body",params : httpParam, responseType : "json",});

  }



  resetPasswd(request:any){
    const params = request;
    let httpParam : HttpParams=new HttpParams();
   
    return this.http.post(environment.API_URL+"/api/auth/user/aux/verifylink",params,{observe : "body",params : httpParam, responseType : "json",});

  }

  logout() {
   
    let httpParam : HttpParams=new HttpParams();

     
     return this.http.post( environment.API_URL +'/api/crm/user/logout',{observe : "body",params : httpParam, responseType : "json",})
       
     
   }
   crossdomainauth() {
   
    let httpParam : HttpParams=new HttpParams();

     
     return this.http.post( environment.API_URL +'/api/crossdomainauth/generate',{observe : "body",params : httpParam, responseType : "json",})
       
     
   }
}
